import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CrudStyles } from '../shared/Crud';
import { ROUTES } from '../../routes';
import RouteEditor from './RouteEditor';
import { PageWrap } from './RotasPage.styles';

const { Container, Header, Button } = CrudStyles;

export default function RoutePlanningPage() {
    const navigate = useNavigate();

    return (
        <PageWrap>
            <Container>
                <Header>
                    <h1>Nova rota</h1>
                    <Button type="button" variant="outline" onClick={() => navigate(ROUTES.ROTAS)}>
                        Voltar à listagem
                    </Button>
                </Header>

                <RouteEditor
                    mode="create"
                    onCreated={(id) => navigate(`${ROUTES.ROTAS}/${id}`)}
                />
            </Container>
        </PageWrap>
    );
}
